import { Box, Tooltip } from "@mui/joy";
import { ApiUserInline } from "griptonite-api-client";

import { Task } from "@/core/types";

import Avatar from "../Avatar";

type Props = {
  task: Task;
};

export default function Assignees({ task }: Props) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        paddingLeft: "8px",
        ">*": {
          marginLeft: "-8px",
        },
      }}
    >
      {task.assignees?.length === 0 ? (
        <Tooltip title="Unassigned">
          <Avatar size={20} />
        </Tooltip>
      ) : (
        task.assignees?.slice(0, 3).map((assignee: ApiUserInline) => (
          <Tooltip key={assignee.uuid} title={`${assignee.firstName} ${assignee.lastName}`}>
            <Avatar size={20} user={assignee} />
          </Tooltip>
        ))
      )}
    </Box>
  );
}
